import { render, staticRenderFns } from "./transRecords.vue?vue&type=template&id=4a89515e&scoped=true&"
import script from "./transRecords.vue?vue&type=script&lang=js&"
export * from "./transRecords.vue?vue&type=script&lang=js&"
import style0 from "./transRecords.vue?vue&type=style&index=0&id=4a89515e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a89515e",
  null
  
)

component.options.__file = "transRecords.vue"
export default component.exports